import { AdvancedMarker, Map } from '@vis.gl/react-google-maps';
import clsx from 'clsx';

import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

import styles from './LocalBranchMap.module.scss';

interface ILocalBranchMap {
  lat: number;
  lng: number;
  branchStreet: string;
  branchCityStateZip: string;
  branchPhone: string;
  branchHours?: string;
}

const LocalBranchMap = ({
  lat,
  lng,
  branchStreet,
  branchCityStateZip,
  branchPhone,
  branchHours,
}: ILocalBranchMap) => (
  <>
    <h5 className={styles.subtitle}>Your Local Branch</h5>

    <div className={styles.mapWrapper}>
      <Map
        center={{ lat, lng }}
        defaultZoom={15}
        gestureHandling="cooperative"
        disableDefaultUI={true}
        mapId={envs[EnvironmentVariable.GoogleMapsID]}
      >
        <AdvancedMarker position={{ lat, lng }} />
      </Map>
    </div>

    <div className={styles.addressWrapper}>
      <div className={styles.addressText}>{branchStreet}</div>
      <div className={styles.addressText}>{branchCityStateZip}</div>

      <a href={`tel:${branchPhone}`} className={clsx(styles.text, styles.linkText)} target="_self">
        {branchPhone}
      </a>

      {branchHours && <div className={styles.addressText}>{branchHours}</div>}
    </div>
  </>
);

export default LocalBranchMap;
